export { default } from './Courses';

export const formatCartItemDataFromPostData = (course, option) => {
	if (course.calendly_course_code) {
		return {
			calendly_course_code: course.calendly_course_code,
			price: course.price ? Number(course.price) : 790,
			pakke: course.name,
			post: {
				id: course.calendly_course_code,
				title: course.name
			}
		};
	} else {
		return {
			code: course.metadata.code,
			id: Number(course.metadata.course_package_id),
			pakke: course.title ? course.title.rendered : course.post_title,
			courses_toward_discount: Number(course.metadata.courses_toward_discount),
			period: course.metadata.period,
			timeplan_option: option ? option : (course.metadata.options ? course.metadata.options[0] : null),
			hoursScope: course.metadata.hours_scope,
			hoursTeaching: course.metadata.hours_teaching,
			price: Number(course.metadata.price),
			studium: course.metadata.studium,
			emne: course.metadata.emne,
			maxPriceType: course.metadata.max_price_type,
			post: {
				id: course.id || course.ID,
				link: course.link,
				title: course.title ? course.title.rendered : course.post_title,
			}
		}
	}
};



// WEBPACK FOOTER //
// ./src/partials/modules/Courses/index.js